
import { mapState } from 'vuex';
import ProductsManager from '@/components/Shop/Products/ProductsManager.vue';
export default {
  data() {
    return {
      brand: null,
      brandId: null,
      pagination: {
        page: 1,
        batchSize: 6,
        total: 0,
        sort: null
      },
      products: [],
      loading: false
    };
  },
  computed: {
    ...mapState('general', ['childProfileHash']),
    targetProfileId() {
      if (this.$auth?.loggedIn)
        return this.childProfileHash?.targetProfileId;
      else
        return null;
    }
  },
  components: {
    ProductsManager
  },
  async fetch() {
    console.log('brands/index ----- fetch start -----');
    try {
      this.loading = true;

      const countryId = this?.$auth?.$state?.user?.country_id ?? 81;
      console.log('brands/index ----- get default shop order start -----');
      const defaultShopOrder = await this.$api.shop.find({
        items: 'defaultShopOrder'
      });
      console.log('brands/index ----- get default shop order end -----', JSON.stringify(defaultShopOrder));

      const { id } = this.$route.params;
      const {
        page = 1,
        sort = defaultShopOrder.sort,
        targetProfileId = this.targetProfileId,
        batchSize = this.pagination.batchSize
      } = this.$route.query;

      console.log('---- get brand url from id start for id ', id);
      this.brand = await this.$api.shop.find({
        items: 'getBrandIdFromURL',
        url: id
      });
      console.log('---- get brand url from id end brand =', this.brand);
      const brandId = this.brand?.brandId ?? id;

      console.log('fetch brand products from api start ----- ')
      const res = await fetchProducts({
        $api: this.$api,
        brandId,
        sort,
        batchSize,
        page,
        targetProfileId,
        countryId
      });
      console.log('fetch brand products from api end ----- ')

      this.brandId = brandId;
      this.products = res.products;
      this.pagination = {
        page: parseInt(page),
        total: res.total,
        batchSize: parseInt(batchSize),
        sort
      };
    } catch (err) {
      console.log('err----', err);
    } finally {
      this.loading = false;
    }
    console.log('brands/index ----- fetch end -----');
  },
  layout(context) {
    return context.$auth.loggedIn ? 'parents' : 'home';
  },
  head() {
    console.log('setting header for SEO ==== brand ', this.brand)
    return {
      title: this.brand?.page_title,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.brand?.meta_description
        },
        {
          hid: 'og:title',
          property: 'og:title',
          content: this.brand?.page_title
        },
        {
          hid: 'og:description',
          property: 'og:description',
          content: this.brand?.meta_description
        },
        {
          hid: 'og:image',
          property: 'og:image',
          content: `${this.$config.API_URL}/${this.brand?.thumbnail_url}`
        },
        {
          hid: 'og:url',
          property: 'og:url',
          content: `${this.$config.DOMAIN_NAME}${this.$nuxt.$route.path}`
        },
        {
          hid: 'og:site_name',
          property: 'og:site_name',
          content: 'BraingGymJr'
        }
      ]
    };
  },
  methods: {
    async onPageChange({ page, batchSize }) {
      this.pagination = {
        ...this.pagination,
        page,
        batchSize
      };
      try {
        this.loading = true;

        const res = await fetchProducts({
          $api: this.$api,
          sort: this.pagination.sort,
          brandId: this.brandId,
          batchSize: this.pagination.batchSize,
          page: this.pagination.page,
          targetProfileId: this.targetProfileId,
          countryId: this.$auth?.user?.shopCountry?.id ?? 81
        });
        this.products = res.products;
        this.pagination.total = res.total;
      } catch (err) {
        console.log(err);
      } finally {
        this.loading = false;
      }
    },
    async changeSortField() {
      this.pagination = {
        ...this.pagination,
        page: 1
      };
      // this.$router.push(
      //   `/shop/brands/${this.$route.params.id}?page=${this.pagination.page}&sortByField=${this.pagination.sortByField}&order=${this.pagination.order}`
      // );
      const res = await fetchProducts({
        $api: this.$api,
        brandId: this.brandId,
        sort: this.pagination.sort,
        batchSize: this.pagination.batchSize,
        page: this.pagination.page,
        targetProfileId: this.targetProfileId,
        countryId: this.$auth?.user?.shopCountry?.id ?? 81
      });
      this.products = res.products;
      this.pagination.total = res.total;
    }
  }
};

async function fetchProducts({
  $api,
  brandId,
  batchSize,
  sort,
  page,
  targetProfileId,
  countryId = 81
}) {
  console.log('fetch brand products inside start ---------');
  const reqData = {
    items: 'products',
    brandId: brandId,
    countryId,
    page: page - 1,
    batchSize: batchSize,
    sort
  };
  if (targetProfileId) reqData.targetProfileId = targetProfileId;

  console.log('fetch brand products inside find req. start ---------');
  const res = await $api.shop.find(reqData);
  console.log('fetch brand products inside find req. end ---------');

  const products = res.results.map(el => {
    let product = {
      ...el.variation,
      ...JSON.parse(el.variation?.extraAttr || '{}')
    };

    const prices = product.countryPricing[countryId];

    if (prices) {
      const { offer_price, actual_price } = prices;
      const percent = ((actual_price - offer_price) / actual_price) * 100;

      product = {
        ...product,
        offer_price,
        actual_price,
        off_percentage: percent.toFixed()
      };
    }
    return { ...el, product };
  });
  console.log('fetch brand products inside end ---------');
  return {
    products,
    total: res.total
  };
}
